import type { HyperEntityConfig } from "@shared/backend/hyper-entity.decorator";
import { canManageBackgroundImages } from "@shared/config/background-image-config";
import { Roles } from "@shared/Roles";
import { remult, repo } from "remult";
import { SubCategory } from "../sub-category";
import { copyApiPrefilterPerRole } from "@shared/backend/entity-security/copy-api-prefilter-per-role";
import { type SubCategoryImage } from "./entity";

function managerPhone() {
  return (remult.user as { phoneNumber?: string } | undefined)?.phoneNumber;
}

async function subCategoryBelongsToManager(subCategoryId: string) {
  if (!canManageBackgroundImages(managerPhone(), remult.user?.roles)) return false;
  const subCategory = await repo(SubCategory).findId(subCategoryId, {
    include: { category: true },
  });
  return subCategory?.category?.organizationId === remult.user?.organizationId;
}

export const SubCategoryImageEntityConfig: HyperEntityConfig<SubCategoryImage> =
  {
    allowApiCrud: Roles.AdminsAndManager,
    apiPrefilterPerRole: async (filter) => {
      filter(Roles.All, {
        subCategory: {
          $is: await copyApiPrefilterPerRole(SubCategory),
        },
      });
    },

    allowInsertPerRole(allow) {
      allow(Roles.OrganizationManagers, (entity) =>
        subCategoryBelongsToManager(entity.subCategoryId),
      );
    },

    allowDeleteAndUpdatePerRole(allow) {
      allow(Roles.OrganizationManagers, (entity) =>
        subCategoryBelongsToManager(entity.subCategoryId),
      );
    },

    id: {
      subCategoryId: true,
      imageId: true,
    },
  };

